import React from 'react';

/* A single skill chip. `index` only feeds the CSS stagger delay. */
export default function SkillTag({ children, tone = 'plain', index = 0, className = '' }) {
  return (
    <span
      className={`hs-skill hs-skill--${tone} ${className}`.trim()}
      style={{ '--hs-i': index }}
    >
      {children}
    </span>
  );
}
